// src/com/auto_cpp_info/AutoCppInfoInput.js
import React, { useEffect, useState } from 'react';
// import { styled } from '@mui/material/styles';
import { Button, DialogContent, DialogActions, Grid, CircularProgress } from '@mui/material';
import { AppWord, AppObject, AppStyle } from '../../value/AppConst';
import { useConfirmDialog } from '../../common/AppConfirmDialog';
import DraggableEditor from '../../common/DraggableEditor';
import VzmNumberField from '../../common/VzmNumberField';
import { ErrorHintBox, VzmPrint } from '../../common/VzmStyled';
import InputUtil from '../../value/InputUtil';
import { AutoCppInfoDictionary } from './AutoCppInfoDict';
import VzmDateField from '../../common/VzmDateField';

const InputMap = AutoCppInfoDictionary.inputMap;

/**
 * (AUTO_CPP_INFO) 정보 생성 또는 편집 Dialog
 * DC별 일일 물동량 볼륨
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-11-01 17:09:26 using DbdbTap
 */
export default function AutoCppInfoInput({
    open,
    isEdit, // 이 데이터의 경우 cppTot하나만 설정하는 것으로, dcCd, planDate는 item에 넣어 전달되어, isEdit로 구분.
    item, // {dcCd, planDate, cppTot, dcName}, isEdit이 false이면 cppTot는 undefined
    onClose,
    onRequestSave,
    responseSaving, // Response if result is NOT OK.
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const openConfirmDialog = useConfirmDialog();
    const {loading:loadingSave, error:errorSave, data:resultSave} = responseSaving; // 전송 결과에 대한 View 기능 소화.

    // const dcTypeCdOptions = ValueMisc.makeCodesToSelectList(codeTree, CodeGroup.DC_TYPE_CD, InputMap.dcTypeCd.id);

    useEffect(()=>{
        if(open) {
            const inputSet = {...AppObject.emptyInputData};
            inputSet.data = {...item};
            if(!isEdit) inputSet.data.cppTot = 0;
            setInput(inputSet);
        }
    }, [open, item, isEdit]);

    const onChangeValue = (id, value, error) => {
        // 사실상 cppTot만 입력하는...
        const newInput = InputUtil.reflectData(input, id, value, error, InputMap, isEdit);
        setInput(newInput);
    };

    const onClickSubmit = () => {
        const param = InputUtil.getDataToSubmit(input.data, InputMap, isEdit);
        onRequestSave(param, isEdit);
    };

    const askCancel = async () => {
        const confirm = await openConfirmDialog({
            ...AppObject.messageCancelEdit,
            option: {yesLabel: AppWord.IgnoreAndClose}
        });
        if(confirm) onClose();
    };

    const onClickCancel = () => {
        if(input.changed) askCancel();
        else onClose();
    };

    // Input field initiallized using getInputField(c,t,i)
    return(
        <DraggableEditor open={open} maxWidth='md'
            title={isEdit ? 'CPP수량 수정' : 'CPP수량 추가'}
        >
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <VzmPrint
                            label="물류센터"
                            value={item.dcName}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <VzmDateField
                            dict={InputMap.planDate}
                            value={input.data.planDate}
                            onChange={onChangeValue}
                            fullWidth={true}
                            disabled={isEdit}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <VzmNumberField
                            dict={InputMap.cppTot}
                            value={input.data.cppTot}
                            onChange={onChangeValue}
                            fullWidth={true}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{display:'flex'}}>
                {
                    input.errorLabels && input.errorLabels.length > 0
                    ?
                    <ErrorHintBox>
                        확인: {input.errorLabels.join(', ')}
                    </ErrorHintBox>
                    : null
                }
                {
                    loadingSave
                    ?
                    <span>
                        <CircularProgress />
                        &nbsp;데이터 저장 중...
                    </span>
                    :
                    <>
                        <Button
                            onClick={onClickSubmit}
                            disabled={input.hasError || !input.changed || loadingSave}
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                        >저장</Button>
                        <Button onClick={onClickCancel}
                            color={AppStyle.mui.warning}
                            variant={AppStyle.mui.contained}
                            disabled={loadingSave}
                        >취소</Button>
                    </>
                }
            </DialogActions>
        </DraggableEditor>
    );
}
